import { render, staticRenderFns } from "./ThemeView.vue?vue&type=template&id=c70141b4"
import script from "./ThemeView.vue?vue&type=script&lang=js"
export * from "./ThemeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports